var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 10C12.5 8.01088 13.2902 6.10322 14.6967 4.6967C16.1032 3.29018 18.0109 2.5 20 2.5C21.9891 2.5 23.8968 3.29018 25.3033 4.6967C26.7098 6.10322 27.5 8.01088 27.5 10C27.5 11.9891 26.7098 13.8968 25.3033 15.3033C23.8968 16.7098 21.9891 17.5 20 17.5C18.0109 17.5 16.1032 16.7098 14.6967 15.3033C13.2902 13.8968 12.5 11.9891 12.5 10ZM6.25166 33.5083C6.30786 29.8991 7.78107 26.4568 10.3533 23.9243C12.9255 21.3918 16.3904 19.9724 20 19.9724C23.6096 19.9724 27.0745 21.3918 29.6467 23.9243C32.2189 26.4568 33.6921 29.8991 33.7483 33.5083C33.7527 33.7513 33.6861 33.9903 33.5567 34.196C33.4274 34.4017 33.2409 34.5653 33.02 34.6667C28.9353 36.5395 24.4936 37.5061 20 37.5C15.3567 37.5 10.945 36.4867 6.98 34.6667C6.75914 34.5653 6.57262 34.4017 6.44327 34.196C6.31391 33.9903 6.24733 33.7513 6.25166 33.5083Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile_icon.f0594b4b22c38d0cf1c405fa1f378a8d.svg";
export { ForwardRef as ReactComponent };